var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 73,
    viewBox: "0 0 67 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6252 37.1692C58.6252 20.4704 46.7327 9.125 33.5002 9.125C20.4072 9.125 8.37516 20.2271 8.37516 37.3517C6.70016 38.3858 5.5835 40.3325 5.5835 42.5833V48.6667C5.5835 52.0125 8.096 54.75 11.1668 54.75H13.9585V36.1958C13.9585 24.4246 22.6964 14.9042 33.5002 14.9042C44.3039 14.9042 53.0418 24.4246 53.0418 36.1958V57.7917H30.7085V63.875H53.0418C56.1127 63.875 58.6252 61.1375 58.6252 57.7917V54.0808C60.2722 53.1379 61.4168 51.2825 61.4168 49.0925V42.0967C61.4168 39.9675 60.2722 38.1121 58.6252 37.1692Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1252 42.5833C26.667 42.5833 27.9168 41.2215 27.9168 39.5417C27.9168 37.8618 26.667 36.5 25.1252 36.5C23.5834 36.5 22.3335 37.8618 22.3335 39.5417C22.3335 41.2215 23.5834 42.5833 25.1252 42.5833Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8752 42.5833C43.417 42.5833 44.6668 41.2215 44.6668 39.5417C44.6668 37.8618 43.417 36.5 41.8752 36.5C40.3334 36.5 39.0835 37.8618 39.0835 39.5417C39.0835 41.2215 40.3334 42.5833 41.8752 42.5833Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2501 33.5496C49.5844 29.2734 47.5517 25.3917 44.5116 22.5916C41.4716 19.7915 37.6204 18.2536 33.6396 18.25C25.1809 18.25 16.0801 25.8846 16.8059 37.8687C20.2484 36.3339 23.2888 33.8948 25.6561 30.7688C28.0234 27.6429 29.644 23.9273 30.3734 19.9533C34.0305 27.9529 41.5401 33.4583 50.2501 33.5496Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.ab1000f737bfd2414d76dea198f83e30.svg";
export { ForwardRef as ReactComponent };